import { defineComponent as _defineComponent } from 'vue'
import { computed, toRef } from 'vue'
import VsText from '@/components/vision/VsText.vue'
import VsCard from '@/components/vision/VsCard.vue'
import { useResourceQuery } from '@/api/unit_numbers'
import { RouterLinkProps } from 'vue-router/types/router'
import { useStore } from 'vuex-composition-helpers'
import Division from '@/models/division'
import ResourceType from '@/models/resource_type'
import Company from '@/models/company'

type RouterLinkTo = RouterLinkProps['to']

enum Status {
  OFFLINE = 0,
  STANDBY = 1,
  ACTIVE = 2,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceCard',
  props: {
    resourceId: null,
    linkTo: null
  },
  setup(__props: any) {

const props = __props as {
  resourceId: string
  linkTo: RouterLinkTo
}



const store = useStore()

const resourceIdRef = toRef(props, 'resourceId')
const { data: resource } = useResourceQuery(resourceIdRef)

const getDivisionById = computed<(id: number | null) => Division>(
  () => store.getters['divisions/getById']
)
const getResourceTypeById = computed<(id: number | null) => ResourceType>(
  () => store.getters['resourceTypes/getById']
)

const getCompanyByOrganizationId = computed<(id: string | null) => Company>(
  () => store.getters['companies/getByOrganizationId']
)

const division = computed(() =>
  getDivisionById.value(resource.value.divisionId)
)
const resourceType = computed(() =>
  getResourceTypeById.value(resource.value.resourceTypeId)
)
const company = computed(() =>
  getCompanyByOrganizationId.value(resource.value.rootOrganizationId)
)

const status = computed(() => {
  switch (resource.value?.status) {
    case Status.OFFLINE:
      return {
        icon: 'mdi-close-circle',
        description: 'Offline',
      }
    case Status.STANDBY:
      return {
        icon: 'pause_circle_filled',
        description: 'Standby',
      }
    case Status.ACTIVE:
      return {
        icon: 'play_circle_filled',
        description: 'Active',
      }
    default:
      return {
        icon: 'help_outline',
        description: 'Loading',
      }
  }
})

return { __sfc: true,props, store, resourceIdRef, resource, getDivisionById, getResourceTypeById, getCompanyByOrganizationId, division, resourceType, company, Status, status, VsText, VsCard }
}

})